import React from 'react'
import { Routes, Route } from 'react-router-dom'
import LoginPage from './admin/pages/login.page'
import { RoutesEnum } from './routes.constants'

const PublicRoutes = () => {
    return (
        <Routes>
            <Route path={RoutesEnum.HOME} element={<LoginPage />} />
            <Route path={RoutesEnum.LOGIN} element={<LoginPage />} />
            <Route path="*" element={<div>404 not found</div>} />
        </Routes>
    )
}

export default PublicRoutes
